/* eslint-disable max-len */

export default {
    name       : 'OperationStatusTimeline',

    /**
     * @override
     */
    data() {
        return {
            operationHistoric: [],
            operationStatusStep: 0,
            statusToChange: {},
            statusesOptions: [
                {
                    keyOptions: ['REGISTERED_ONLINE', 'REGISTERED_EMAIL', 'REGISTERED_POSTAL', 'REGISTERED'],
                    key: 'REGISTERED',
                    date: null,
                    complete: true,
                    type: 'all',
                    user: null
                },
                {
                    key: 'SIGNED',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'all'
                },
                {
                    key: 'CANCELLED',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'all-cancelled'
                },
                {
                    key: 'VALIDATED',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'all'
                },
                {
                    key: 'RD_SENT',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'all'
                },
                // {
                //     key: 'SNCE_1',
                //     date: null,
                //     complete: false,
                //     user: null,
                //     type: 'traspaso_externo_entrada'
                // },
                {
                    key: 'SOLICITUD_PENDIENTE_ENVIO_INTERCAMBIO',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'traspaso_externo_entrada'
                },
                // {
                //     key: 'SNCE_2',
                //     date: null,
                //     complete: false,
                //     user: null,
                //     type: 'traspaso_externo_entrada'
                // },
                {
                    key: 'SOLICITUD_ENVIADA_A_GESTORA_ORIGEN',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'traspaso_externo_entrada'
                },
                // {
                //     key: 'SNCE_3',
                //     date: null,
                //     complete: false,
                //     user: null,
                //     type: 'traspaso_externo_entrada'
                // },
                {
                    key: 'RECIBIDO_RECHAZO',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'traspaso_externo_entrada'
                },
                {
                    key: 'TRASPASO_RECIBIDO_PENDIENTE_VALORAR',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'traspaso_externo_entrada'
                },
                // {
                //     key: 'SNCE_1',
                //     date: null,
                //     complete: false,
                //     user: null,
                //     type: 'traspaso_externo_salida'
                // },
                {
                    key: 'SOLICITUD_TRASPASO_SALIDA_PENDIENTE',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'traspaso_externo_salida'
                },
                // {
                //     key: 'SNCE_2',
                //     date: null,
                //     complete: false,
                //     user: null,
                //     type: 'traspaso_externo_salida'
                // },
                {
                    key: 'TRASPASO_SALIDA_GENERADO_PENDIENTE_VALORAR',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'traspaso_externo_salida'
                },
                // {
                //     key: 'SNCE_3',
                //     date: null,
                //     complete: false,
                //     user: null,
                //     type: 'traspaso_externo_salida'
                // },
                {
                    key: 'ENVIADO_RECHAZO',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'traspaso_externo_salida'
                },
                {
                    key: 'TRANSFERENCIA_ENVIADA',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'traspaso_externo_salida'
                },
                {
                    key: 'FINALIZED',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'all'
                },
                {
                    key: 'PERIODIC_ACTIVE',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'periodic'
                },
                {
                    key: 'PERIODIC_SUSPENDED',
                    date: null,
                    complete: false,
                    user: null,
                    type: 'periodic-suspended'
                }
            ],
            statuses: []
        };
    },
    props: {
        operation: {
            type: Object,
            required: true
        }
    },
    methods: {
        /**
         * Obtenemos la información relativa al historico de la operación
         */
        fetchData() {
            const cfg = {};
            cfg.params = {};
            if (this.limit) {
                cfg.params.$limit = this.limit;
            }
            this.$operationsService.getOperationHistoric(this.operation.operation_id, cfg)
                .then(res => {
                    this.operationHistoric = res.data.operations_historical;
                    this.operationHistoric.map(item => {
                        for (let index = 0; index < this.statuses.length; index++) {
                            const element = this.statuses[index];
                            if (element.key === item.status || (element.keyOptions && element.keyOptions.includes(item.status))) {
                                element.key = item.status;
                                element.date = item.created_on;
                                element.complete = true;
                                element.user = item.user_info;
                            }
                        }
                        return item;
                    });
                });
        },
        // si el estado firmado no tiene fecha significa que se ha saltado a validado y por lo tanto usamos la fecha de validación
        getSignedStatusDate(signedStatusDate) {
            if (!signedStatusDate) {
                const validatedStatus = this.statuses.find(status => ['VALIDATED', 'VALIDADO'].includes(status.key));
                return validatedStatus ? validatedStatus.date : undefined;
            }
            return signedStatusDate;
        },
        // Permite excluir los estados del tipo SNCE_* cuando no se han seleccionado, de manera que solo aparezca SNCE_*
        // Solo muestra el subestado que realmente existe en el histórico, siempre y cuando dos subestados no sean excluyentes entre sí
        // eslint-disable-next-line
        checkExcludes(step) {
            const values = [
                'SNCE_1', 'SOLICITUD_PENDIENTE_ENVIO_INTERCAMBIO', 'SOLICITUD_TRASPASO_SALIDA_PENDIENTE',
                'SNCE_2', 'SOLICITUD_ENVIADA_A_GESTORA_ORIGEN', 'TRASPASO_SALIDA_GENERADO_PENDIENTE_VALORAR',
                'SNCE_3', 'RECIBIDO_RECHAZO', 'TRASPASO_RECIBIDO_PENDIENTE_VALORAR', 'ENVIADO_RECHAZO', 'TRANSFERENCIA_ENVIADA'
            ];

            return (values.indexOf(step.key) === -1)
            || (step.key === 'RECIBIDO_RECHAZO' && this.operationHistoric.some(item => item.status === 'RECIBIDO_RECHAZO') && !this.operationHistoric.some(item => item.status === 'TRASPASO_RECIBIDO_PENDIENTE_VALORAR'))
            || (step.key === 'TRASPASO_RECIBIDO_PENDIENTE_VALORAR' && this.operationHistoric.some(item => item.status === 'TRASPASO_RECIBIDO_PENDIENTE_VALORAR') && !this.operationHistoric.some(item => item.status === 'RECIBIDO_RECHAZO'))
            || (step.key === 'SOLICITUD_PENDIENTE_ENVIO_INTERCAMBIO' && this.operationHistoric.some(item => item.status === 'SOLICITUD_PENDIENTE_ENVIO_INTERCAMBIO'))
            || (step.key === 'SOLICITUD_ENVIADA_A_GESTORA_ORIGEN' && this.operationHistoric.some(item => item.status === 'SOLICITUD_ENVIADA_A_GESTORA_ORIGEN'))
            || (step.key === 'SOLICITUD_TRASPASO_SALIDA_PENDIENTE' && this.operationHistoric.some(item => item.status === 'SOLICITUD_TRASPASO_SALIDA_PENDIENTE'))// Salida
            || (step.key === 'TRASPASO_SALIDA_GENERADO_PENDIENTE_VALORAR' && this.operationHistoric.some(item => item.status === 'TRASPASO_SALIDA_GENERADO_PENDIENTE_VALORAR'))// Salida
            || (step.key === 'ENVIADO_RECHAZO' && this.operationHistoric.some(item => item.status === 'ENVIADO_RECHAZO') && !this.operationHistoric.some(item => item.status === 'TRANSFERENCIA_ENVIADA'))// Salida
            || (step.key === 'TRANSFERENCIA_ENVIADA' && this.operationHistoric.some(item => item.status === 'TRANSFERENCIA_ENVIADA') && !this.operationHistoric.some(item => item.status === 'ENVIADO_RECHAZO'))// Salida
            // || (step.key === 'SNCE_1'
            //     && !this.operationHistoric.some(item => item.status === 'SOLICITUD_PENDIENTE_ENVIO_INTERCAMBIO')
            //     && !this.operationHistoric.some(item => item.status === 'SOLICITUD_TRASPASO_SALIDA_PENDIENTE'))// Salida
            // || (step.key === 'SNCE_2'
            //     && !this.operationHistoric.some(item => item.status === 'SOLICITUD_ENVIADA_A_GESTORA_ORIGEN'))
            //     && !this.operationHistoric.some(item => item.status === 'TRASPASO_SALIDA_GENERADO_PENDIENTE_VALORAR')// Salida
            // || (step.key === 'SNCE_3'
            //     && !this.operationHistoric.some(item => item.status === 'RECIBIDO_RECHAZO')
            //     && !this.operationHistoric.some(item => item.status === 'TRASPASO_RECIBIDO_PENDIENTE_VALORAR')
            //     && !this.operationHistoric.some(item => item.status === 'ENVIADO_RECHAZO')// Salida
            //     && !this.operationHistoric.some(item => item.status === 'TRANSFERENCIA_ENVIADA'));// Salida
        }
    },
    /**
     * @override
     */
    mounted() {
        this.fetchData();
        this.statuses = this.statusesOptions.filter(item => {
            const PERIODIC_OPERATION_TYPES = [
                'SOLICITUD_SUSCRIPCION_PERIODICA',
                'SOLICITUD_REEMBOLSO_PERIODICO',
                'SOLICITUD_APORTACION_PERIODICA',
                'SUSCRIPCION_PERIODICA',
                'REEMBOLSO_PERIODICO',
                'APORTACION_PERIODICA'
            ];
            const isPeriodic = PERIODIC_OPERATION_TYPES.includes(this.operation.key_operation_type);
            // Excluir los pasos "RD_SENT" y "FINALIZED" para suscripciones periódicas
            if (isPeriodic && ['RD_SENT', 'FINALIZED'].includes(item.key)) {
                return false;
            }
            return ( this.operation.key_operation_type === 'SOLICITUD_TRASPASO_EXTERNO_ENTRADA' && item.type === 'traspaso_externo_entrada'
                || this.operation.key_operation_type === 'SOLICITUD_TRASPASO_EXTERNO_SALIDA' && item.type === 'traspaso_externo_salida'
                || item.type === 'all'
                || this.operation.operation_status === 'CANCELLED' && item.type === 'all-cancelled'
                || this.operation.operation_status === 'PERIODIC_SUSPENDED' && item.type === 'periodic-suspended' 
                    // Nuevo filtro para subscripción periódica
                || (this.operation.key_operation_type === 'SUSCRIPCION_PERIODICA' || this.operation.key_operation_type === 'SOLICITUD_SUSCRIPCION_PERIODICA' || this.operation.key_operation_type === 'SOLICITUD_REEMBOLSO_PERIODICO') && (
                    item.key === 'PERIODIC_ACTIVE'
                ));           
        });

        // TODO: Imlement RD case
        if (this.operation.source_system === 'RD') {
            this.statuses = this.statusesOptions.filter(item => item.key === 'FINALIZED');
        }

        for (let i = 0; i < this.statuses.length; i++) {
            const element = this.statuses[i];
            if (element.key === this.operation.operation_status) {
                this.operationStatusStep = i;
            }
        }
    }
};
